const tab_sections = {
    identity: 'Identidade',
    integrations: 'Ligações',
    login_security: 'Acesso e segurança',
    permissions: 'Permissões',
    automation: 'Automatização',
    platform: 'Plataforma',
    overview: 'Visão geral',
    authentication: 'Autenticação',
    authorization: 'Autorização',
    users: 'Utilizadores',
    developer: 'Desenvolvedor',
    tenant: 'Inquilino',
};
export default Object.freeze(tab_sections);
